import React, { useEffect } from 'react';

import './merch.css'

const Merch = () => {
    return (
        <div className='App-page faq-page merch-page'>
            <h1>Join the Double Edge Games Mailing List</h1>
            <h4>Sign up today and be the first to know about new projects and developments we are working on, receive special occasion discount codes, and stay on top of all the recent developments in Relic Arena!</h4>

            <div className="report-bug-box">
                <form className="report-bug-form validate" action="https://relicarena.us17.list-manage.com/subscribe/post?u=c2b31ddfe2fb203128a628840&amp;id=5000408046&amp;v_id=2&amp;f_id=003ec2e1f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" target="_blank">
					<div className="form-field">
                        <label htmlFor="mce-FNAME">First Name</label>
                        <input type="text" name="FNAME" className="text" id="mce-FNAME"/>
					</div>
                    <div className="form-field">
                        <label htmlFor="mce-LNAME">Last Name</label>
                        <input type="text" name="LNAME" className="text" id="mce-LNAME"/>
					</div>
                    <div className="form-field">
                        <label htmlFor="mce-EMAIL">Email Address <span className="required">*</span></label>
                        <input type="text" name="EMAIL" className="text" id="mce-EMAIL" required/>
					</div>
                    <div className="form-fieldset">
                        <p>Please select all the ways you would like to hear from us:</p>
                        <fieldset>
                            <label className="checkbox subfield" htmlFor="gdpr_26">
                                <input type="checkbox" id="gdpr_26" name="gdpr[26]" className="gdpr" value="Y"/>
                                <span>Email</span>
                            </label>
                        </fieldset>
                    </div>
                    <p>We use Mailchimp as our marketing platform. By clicking below to subscribe, you acknowledge that your information will be transferred to Mailchimp for processing. <a href="https://mailchimp.com/legal/terms">Learn more</a> about Mailchimp's privacy practices.</p>
                    <input type="hidden" name="tags" value="377"/>
                    <div id="mce-responses" className="clear">
                        <div className="response" id="mce-error-response" style={{ display: 'none' }}></div>
                        <div className="response" id="mce-success-response" style={{ display: 'none' }}></div>
                    </div>
                    <div aria-hidden="true" style={{ position: 'absolute', left: '-5000px' }}>
                        <input type="text" name="b_c2b31ddfe2fb203128a628840_5000408046" tabIndex="-1"/>
                    </div>
					<div className="form-submit">
						<button type="submit" name="subscribe" id="mc-embedded-subscribe" disabled={false}>Subscribe</button>
					</div>
				</form>
			</div>
        </div>
    );
};

export default Merch;
